<ng-container *transloco="let t">

<div class="modal-header">

  <h2>{{ t('portal.tasks.answerQuestion') }}</h2>

  <!-- hack to fool ngbModal autofocus -->
  <input type="text" style="display:none" />

  <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" aria-label="Close"
    (click)="activeModal.dismiss()">
    <span class="svg-icon svg-icon-2x">
      <close-x-svg-icon></close-x-svg-icon>
    </span>
  </div>
</div>

<div class="modal-body py-10 px-lg-17">
  <h4 class="mb-4">{{ task | taskText:'description' }}</h4>
  <form #answerForm="ngForm" class="form" novalidate id="answerForm" name="answerForm">
    <div class="form-group mb-5 col-md-12">
      <label class="form-label" for="answer">{{ t('portal.tasks.provideAnswerBelow') }}</label>
      <textarea required
        #borrowerAnswer="ngModel"
        class="form-control" rows="5"
        [ngClass]="{'is-invalid' : borrowerAnswer && borrowerAnswer.touched && borrowerAnswer.invalid}"
        [(ngModel)]="answer" name="answer">
      </textarea>
      <div class="invalid-feedback">{{ t('portal.tasks.pleaseEnterAnswer') }}</div>
    </div>
  </form>
</div>

<div class="modal-footer flex-center">
  <button type="button" class="btn btn-white me-3" (click)="activeModal.dismiss()">{{ t('common.cancel') }}</button>
  <button type="button" class="btn btn-primary" (click)="onOkClicked()">{{ t('portal.tasks.done') }}</button>
</div>



</ng-container>
